export const TruckCardSkeleton = () => (
  <div className="bg-white rounded-2xl shadow-warm overflow-hidden animate-pulse" data-testid="truck-skeleton">
    <div className="h-44 bg-cream-bg" />
    <div className="p-4 space-y-3">
      <div className="h-3 w-1/3 bg-cream-bg rounded" />
      <div className="h-5 w-3/4 bg-cream-bg rounded" />
      <div className="h-3 w-1/2 bg-cream-bg rounded" />
      <div className="h-3 w-full bg-cream-bg rounded" />
      <div className="h-3 w-1/3 bg-cream-bg rounded mt-4" />
    </div>
  </div>
);

export const TruckGridSkeleton = ({ count = 8 }) => (
  <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4 mt-6" data-testid="truck-grid-skeleton">
    {Array.from({ length: count }).map((_, i) => <TruckCardSkeleton key={i} />)}
  </div>
);
